import { render, staticRenderFns } from "./SplitOrderReferenceButtonActionModal.vue?vue&type=template&id=65aced56&"
import script from "./SplitOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"
export * from "./SplitOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports